import React from "react"
import BaseSubheadline from "../common/BaseSubheadline"
import { SecondaryHeadingSplitTextImageType } from "../../types/mainModulTypes"
import BaseRichtext from "../common/BaseRichtext"
import { API } from "../../constants/constants"

export default function SecondaryHeadingSplitTextImage(props: SecondaryHeadingSplitTextImageType) {
    return (
        <div className="max-w-content mx-auto px-4 lg:px-0 border-x-4 border-transparent">
            <BaseSubheadline label={props.secondaryHeadingSplitTextImageHeading} classProps="w-full text-left sm:text-center pb-4 sm:pb-8" />
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-12 pb-4 border-x-4 border-transparent">
                <BaseRichtext content={props.secondaryHeadingSplitTextImageTextLeft} />
                <BaseRichtext content={props.secondaryHeadingSplitTextImageTextRight} />
            </div>
            <img
                src={API + props.secondaryHeadingSplitTextImageImage?.url}
                alt={props.secondaryHeadingSplitTextImageImage?.description ?? props.secondaryHeadingSplitTextImageImage?.name}
                className="w-full aspect-[6/3] sm:aspect-[10/3] object-cover border-4 border-accent rounded-default"
            />
        </div>
    )
}
